module.exports = __webpack_public_path__ + "static/media/vector-square.517c6b2f.svg";